
const images = [
  { id: 1, thumbnail: "/assets/image-1.webp" },
  { id: 2, thumbnail: "/assets/image-2.webp" },
  { id: 3, thumbnail: "/assets/image-3.webp" },
  { id: 4, thumbnail: "/assets/image-4.webp" },
  { id: 5, thumbnail: "/assets/image-5.webp" },
  { id: 6, thumbnail: "/assets/image-6.webp" },
  { id: 7, thumbnail: "/assets/image-7.webp" },
  { id: 8, thumbnail: "/assets/image-8.webp" },
  { id: 9, thumbnail: "/assets/image-9.webp" },
  { id: 10, thumbnail: "/assets/image-10.jpeg" },
  { id: 11, thumbnail: "/assets/image-11.jpeg" },
];

export default images;
